import { Link } from "react-router-dom";
import { ArrowRight, Upload, Palette, Truck } from "lucide-react";
import { PosterCanvas } from "@/components/PosterCanvas";
import { ReviewsSection } from "@/components/ReviewsSection";
import { InstagramSection } from "@/components/InstagramSection";
import { TEMPLATES, configFromTemplate, DELIVERY_DELAY } from "@/lib/poster";

const HERO_IMG = "/hero-mariage.jpg";
const steps = [
  { icon: Palette, title: "Composez", text: "Modèle, format, couleurs au code HEX près, textes et polices." },
  { icon: Upload, title: "Importez vos photos", text: "Chacun importe sa photo : l'arrière-plan est retiré automatiquement, sans aucune retouche." },
  { icon: Truck, title: "Recevez-le", text: `Impression fidèle à l'aperçu validé, livrée sous ${DELIVERY_DELAY}.` },
];

export default function Home() {
  return (
    <div>
      <section className="relative aspect-[3/4] sm:aspect-auto sm:h-[calc(100svh-113px)] sm:min-h-[540px] overflow-hidden bg-[#F6F0EB]" data-testid="hero-banner">
        <div className="absolute inset-0 bg-[#CDC0B0]">
          <img src={HERO_IMG} alt="" aria-hidden className="absolute inset-0 w-full h-full object-cover scale-110 blur-2xl opacity-70" />
          <img src={HERO_IMG} alt="Tableau Marwa & Salah sur chevalet" className="absolute inset-0 w-full h-full object-contain object-bottom drop-shadow-2xl" data-testid="hero-image" />
          <div className="hero-fade absolute inset-x-0 -bottom-px h-[42%] sm:h-[30%]" />
        </div>
        <div className="absolute inset-x-0 bottom-0 z-10 max-w-[1100px] mx-auto px-4 sm:px-6 flex flex-col items-center justify-end text-center pb-5 sm:pb-6 fade-up">
          <span data-testid="hero-eyebrow" className="text-[10px] sm:text-xs uppercase tracking-[0.35em] text-white drop-shadow-[0_1px_4px_rgba(58,50,43,0.55)]">Tableaux de mariage & souvenirs</span>
          <h1 data-testid="hero-title" className="font-display text-2xl sm:text-4xl lg:text-5xl leading-[1.1] text-[#3A322B]/90 mt-2">
            Votre plus beau jour, <em>composé par vous.</em>
          </h1>
          <div className="flex flex-nowrap justify-center gap-2 sm:gap-3 mt-3 sm:mt-5 whitespace-nowrap">
            <Link to="/configurateur" className="btn-gold text-xs sm:text-sm !px-4 sm:!px-6" data-testid="hero-cta-button">Créer mon tableau <ArrowRight size={16} /></Link>
            <Link to="/suivi" className="btn-outline text-xs sm:text-sm !px-4 sm:!px-6 bg-white/50 backdrop-blur-md" data-testid="hero-tracking-button">Suivre une commande</Link>
          </div>
        </div>
      </section>

      <section className="grad-ivory border-y border-[#DDD3C6]">
        <div className="max-w-[1500px] mx-auto px-6 lg:px-10 py-20 grid md:grid-cols-3 gap-12">
          {steps.map((s, i) => (
            <div key={s.title} className="space-y-4 text-center fade-up" style={{ animationDelay: `${i * 120}ms` }}>
              <h3 className="font-display text-2xl uppercase tracking-[0.12em] flex items-center justify-center gap-3"><s.icon className="text-[#7B5338] shrink-0" />{s.title}</h3>
              <p className="text-[#6B5F53] leading-relaxed">{s.text}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="blob-bg max-w-[1500px] mx-auto px-6 lg:px-10 py-24" data-testid="templates-section">
        <div className="flex flex-wrap justify-between items-end gap-6 mb-12">
          <div><span className="label-xs">Nos modèles</span><h2 className="font-display text-4xl lg:text-5xl mt-3 text-gradient">Choisissez votre point de départ</h2></div>
          <p className="text-[#6B5F53] max-w-md">Deux formats de panneaux en Forex : 50 × 70 cm (90 €) et 60 × 80 cm (110 €). Trépied et support non fournis.</p>
        </div>
        <div className="grid md:grid-cols-3 gap-10">
          {TEMPLATES.map((t) => (
            <Link key={t.id} to={`/configurateur?modele=${t.id}`} data-testid={`home-template-${t.id}`}
              className="group flex flex-col grad-card border border-[#C2B4A2]/70 rounded-3xl p-6 lg:p-8 transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-[0_24px_50px_-20px_rgba(58,50,43,0.35)]">
              <h3 className="font-display text-3xl tracking-[0.2em] text-center text-[#3A322B] pb-5 mb-6 border-b border-[#C2B4A2]" data-testid={`home-template-title-${t.id}`}>{t.name}</h3>
              <div className="h-[420px]">
                <PosterCanvas cfg={configFromTemplate(t)} photos={{}} testId={`home-template-canvas-${t.id}`} />
              </div>
              <p className="text-sm text-[#6B5F53] mt-6 text-center leading-relaxed flex-1">{t.tagline}</p>
              <span className="mt-6 self-center btn-gold text-sm">Personnaliser <ArrowRight size={14} /></span>
            </Link>
          ))}
        </div>
      </section>

      <ReviewsSection />
      <InstagramSection />
    </div>
  );
}
